import styled, { keyframes } from 'styled-components/macro';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const StyledInlineSpinner = styled.svg`
  animation: ${spin} 1000ms linear infinite;
`;
